"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgDeviceSvg = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ className: "DeviceSVG_svg__currentColor", fill: "none", height: 17, width: 22, xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ stroke: "currentColor" }, { children: [(0, jsx_runtime_1.jsx)("rect", { fill: "currentColor", height: 2, rx: 0.5, width: 21, x: 0.5, y: 14.5 }), (0, jsx_runtime_1.jsxs)("g", __assign({ strokeWidth: 1.5 }, { children: [(0, jsx_runtime_1.jsx)("rect", { height: 15, rx: 2, width: 18, x: 2, y: 1 }), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M13.715 5.38c.17.056.285.209.285.38v2.51c0 .7-.269 1.37-.744 1.889a3.026 3.026 0 0 1-.862.629l-1.392.712-1.393-.712a3.024 3.024 0 0 1-.864-.63A2.797 2.797 0 0 1 8 8.269V5.76c0-.171.114-.324.285-.38l2.574-.857a.449.449 0 0 1 .282 0z", opacity: 0.4, strokeLinecap: "round", strokeLinejoin: "round" })] }))] })) }))); };
exports.default = SvgDeviceSvg;
